var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1364_1478",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.518555,
    y: 0.199219,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1364_1478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.13405 20.1989C7.68655 20.1989 7.30539 20.0416 6.99055 19.7269C6.67589 19.4121 6.51855 19.0309 6.51855 18.5834V6.19894H5.51855V5.19894H9.51855V4.42969H15.5186V5.19894H19.5186V6.19894H18.5186V18.5834C18.5186 19.0438 18.3644 19.4281 18.0561 19.7364C17.7477 20.0448 17.3634 20.1989 16.9031 20.1989H8.13405ZM17.5186 6.19894H7.51855V18.5834C7.51855 18.7629 7.57622 18.9104 7.69156 19.0259C7.80705 19.1413 7.95455 19.1989 8.13405 19.1989H16.9031C17.0571 19.1989 17.1981 19.1349 17.3263 19.0067C17.4545 18.8785 17.5186 18.7374 17.5186 18.5834V6.19894ZM10.3263 17.1989H11.3263V8.19894H10.3263V17.1989ZM13.7108 17.1989H14.7108V8.19894H13.7108V17.1989Z",
    fill: "#B2B2B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.995cbbf19b873d51555e0859b487b4d1.svg";
export { ForwardRef as ReactComponent };